import { Action } from '../../types';
import { GetRolePermissions_getPermissionRoles as getPermissionRoles } from '../../../types/schemaTypes';
import { GetRolePermissions_getPermissionRoles_categories as getPermissionCategories } from '../../../types/schemaTypes';

export enum Actions {
    SET_INITIAL_DATA = 'PERMISSION_ROLE_EDIT_SET_INITIAL_DATA',
    UPDATE_PERMISSION_CATEGORY = 'UPDATE_PERMISSION_CATEGORY',
    UPDATE_GRID_DATA = 'UPDATE_GRID_DATA',
    SAVE_AND_CLEAR_POSTED_DATA = 'SAVE_AND_CLEAR_POSTED_DATA',
}

export const updatePermissionCategory = (data: getPermissionCategories): Action => ({
    type: Actions.UPDATE_PERMISSION_CATEGORY,
    payload: data,
    error: null,
});
export const setInitialData = (data: getPermissionRoles): Action => ({
    type: Actions.SET_INITIAL_DATA,
    payload: data,
    error: null,
});

export const updateGridData = (roleId: number, permissionId: number, editTypeId: boolean): Action => ({
    type: Actions.UPDATE_GRID_DATA,
    payload: {
        roleId,
        permissionId,
        editTypeId,
    },
    error: null,
});

export const saveAndClearPostedData = (): Action => ({
    type: Actions.SAVE_AND_CLEAR_POSTED_DATA,
    payload: {},
    error: null,
});
